import { render, staticRenderFns } from "./SupplierAgentInformation.vue?vue&type=template&id=6ea8a72e&"
import script from "./SupplierAgentInformation.vue?vue&type=script&lang=js&"
export * from "./SupplierAgentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports